import { createStyles, keyframes } from '@mantine/core';
var pulse = keyframes({
  "from, to": {
    opacity: 1
  },
  "50%": {
    opacity: 0.75
  }
});
var useStyles = createStyles(function () {
  return {
    activeSystem: {
      animation: "".concat(pulse, " 1s ease-in-out 0.5s 5")
    },
    passiveSystem: {},
    pointer: {
      cursor: "pointer"
    },
    neutral: {
      fill: "#FFFFFF",
      stroke: "#FFFFFF"
    },
    amarr: {
      fill: "#E7B815",
      stroke: "#E7B815"
    },
    minmatar: {
      fill: "#FE3743",
      stroke: "#FE3743"
    },
    caldari: {
      fill: "#00ACD1",
      stroke: "#00ACD1"
    },
    gallente: {
      fill: "#40AA5E",
      stroke: "#40AA5E"
    },
    angel: {
      fill: "#FFE1B0",
      stroke: "#FFE1B0"
    },
    guristas: {
      fill: "#FF7F00",
      stroke: "#FF7F00"
    },
    systemTransitions: {
      "*": {
        transition: "filter 500ms ease, stroke 500ms ease, fill 500ms ease, fill-opacity 500ms ease, stroke-opacity 70ms ease 0s ",
        pointerEvents: "auto"
      },
      "&:hover": {
        path: {
          strokeOpacity: 1,
          strokeWidth: 30
        }
      }
    },
    selectedSystem: {
      path: {
        strokeOpacity: 1,
        strokeWidth: 15
      }
    },
    border: {
      fill: "none",
      strokeWidth: 10
    },
    fill: {
      stroke: "none",
      pointerEvents: "auto",
      cursor: "pointer"
    },
    fillFilter: {
      "@supports (-moz-appearance:none)": {
        filter: "brightness(0.45)"
      }
    },
    frontline: {
      fillOpacity: 0.85,
      strokeOpacity: 0.85
    },
    secondline: {
      fillOpacity: 0.45,
      strokeOpacity: 0.45
    },
    backline: {
      fillOpacity: 0.2,
      strokeOpacity: 0.2
    },
    unknown: {
      fillOpacity: 0.5,
      strokeOpacity: 0.5
    }
  };
});
export { useStyles as default, pulse };